import { render, staticRenderFns } from "./ObrasCadastro.vue?vue&type=template&id=de031fca&scoped=true&"
import script from "./ObrasCadastro.vue?vue&type=script&lang=js&"
export * from "./ObrasCadastro.vue?vue&type=script&lang=js&"
import style0 from "./ObrasCadastro.vue?vue&type=style&index=0&id=de031fca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de031fca",
  null
  
)

export default component.exports